import script from "./lot.vue?vue&type=script&setup=true&lang=js"
export * from "./lot.vue?vue&type=script&setup=true&lang=js"

import "./lot.vue?vue&type=style&index=0&id=2dcac8f8&scoped=true&lang=css"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dcac8f8"]])

export default __exports__